import { useEffect } from 'react'

import { dispatch } from 'store'
import { campaignThunks } from 'store/features/campaign/thunks'
import { setSocketListener, removeSocketListener } from 'services/socket/socket'

// Socket message for campaign pushes — same message the rf-components offer
// popup listens for (`type === 'notification'`).
interface ICampaignSocketMessage {
  type?: string
}

const NOTIFICATION_SOCKET_TYPE = 'notification'

// Feeds the campaign slice the header discount button reads from:
// - on mount, picks the active campaign out of the notifications API;
// - live, re-reads the notifications when a campaign notification arrives
//   over the shared socket. Must be called after useAppSockets so the socket
//   connection exists when the listener attaches.
export const useCampaignListener = () => {
  useEffect(() => {
    dispatch(campaignThunks.initCampaignFromNotifications())

    const onSocketEvent = (message: ICampaignSocketMessage) => {
      if (message?.type !== NOTIFICATION_SOCKET_TYPE) return

      dispatch(campaignThunks.initCampaignFromNotifications())
    }

    setSocketListener(onSocketEvent)

    return () => removeSocketListener(onSocketEvent)
  }, [])
}
